import React from 'react';

const Input = (props) => {
    const {
        name        = '',
        value       = '',
        type        = 'text',
        onChange    = (value) => {},
        disabled    = false
    } = props;

    return (
        <input type={type}
               value={value}
               onChange={(event) => onChange(event.target.value)}
               disabled={disabled}
               name={name}
               id={name}
               className={'input-field'}
               autoComplete="off"
        />
    );
}

export default Input;
